export default __webpack_public_path__ + "static/media/line.c7bab290.svg";